module.exports = __webpack_public_path__ + "static/media/top_artworks1.0f1c43e5.jpeg";